import React from 'react'
import PropTypes from 'prop-types'

import Validator from 'validatorjs'
import request from 'utils/request'
import { connect } from 'react-redux'

import BaseComponent from 'utils/BaseComponent'

import Input from 'components/Input'
import Button from 'components/Button'
import Select from 'components/Select'

import { CREATE_CITY_URL } from 'constants'

import { statusChanged } from 'components/RequestStatus/actions'

import './styles.scss'


export class AddLocation extends BaseComponent {
  static validationRules = {
    name: 'string|required|min:2',
    confirmation: 'string|required'
  }

  constructor(props) {
    super(props)

    this._bind('_handleChange', '_handleSubmit', '_validate', '_handleSelect')

    this.state = {
      buttonProps: {
        disabled: true
      },
      state: {
        id: null,
        name: ''
      },
      formData: {
        name: '',
        confirmation: '',
      },
      errors: {}
    }

    this._bind('_toggleModal')
  }

  componentDidMount() {
    if( !!this.props.state ) {
      const state = {...this.props.state}
      this.setState({ state })
    }
  }

  _handleSubmit(e) {
    e.preventDefault()
    this.props.updateRequestStatus('progress', 'Creando localidad...')
    request(CREATE_CITY_URL, {
      method: 'POST',
      body: {
        state: this.state.state.id,
        name: this.state.formData.name
      }
    })
      .then((res) => {
        this.props.updateRequestStatus(res.status, res.message)
        this.props.onCreated(this.state.state, res.city)
        this._toggleModal(false)
      })
  }

  _handleChange(e) {
    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.value
      }
    })
    this._validate(e.target.name, e.target.value)
  }

  _validate(name, value) {
    const formData = {
      ...this.state.formData,
      [name]: value
    }
    const validator = new Validator(formData, AddLocation.validationRules)
    this.setState({
      buttonProps: {
        disabled: !(validator.passes() && formData.confirmation.toUpperCase() === 'CREAR LOCALIDAD')
      }
    })
  }

  _toggleModal(visible) {
    const toggleFunc = this.props.isSecondModal ? this.context.secondToggleModal : this.context.toggleModal
    toggleFunc(visible)
  }

  _handleSelect(selectedOption) {
    const id = !!selectedOption ? selectedOption.value : null,
      name = !!selectedOption ? selectedOption.label : null
    this.setState({
      state: { id, name }
    })
  }


  render() {
    const formData = this.state.formData
    return (
      <div id="AddLocation" className="EditModal Modal__content">
        <div className="EditModal__header d-flex justify-content-between align-items-center">
          <h1>Crear Nueva localidad</h1>
          <span className="material-icons close-button" onClick={() => this._toggleModal(false)}>clear</span>
        </div>
        <form onSubmit={this._handleSubmit} className="f-flex EditModal__form">
          <div className="modal-elements-container justify-content-center">
            <Select
              onChange={this._handleSelect}
              options={this.props.options}
              value={this.state.state.id}
              placeholder="Estado *" />
            <Input
              errors={this.state.errors.name}
              label="Nombre de la nueva localidad"
              name="name"
              onChange={this._handleChange}
              placeholder="Nombre*"
              type="text"
              autoComplete="off"
              value={formData.name}
            />
          </div>
          <p className="message">
            Estás a punto de crear una localidad, esta es una acción irreversible. Para completar esta acción, escribe <span>crear localidad</span>
          </p>
          <div className="controls d-flex justify-content-between align-items-center">
            <Input
              errors={this.state.errors.confirmation}
              name="confirmation"
              onChange={this._handleChange}
              placeholder="Confirmación*"
              type="text"
              autoComplete="off"
              value={formData.confirmation}
            />
            <Button id="editPasswordButton"
                    type="submit"
                    className="button"
                    size="big"
                    buttonType="danger"
                    {...this.state.buttonProps}>Agegar nueva localidad</Button>
          </div>
        </form>
      </div>
    )
  }
}

AddLocation.contextTypes = {
  toggleModal: PropTypes.func.isRequired,
  secondToggleModal: PropTypes.func.isRequired
}

AddLocation.defaultProps = {
  isSecondModal: false
}

AddLocation.propTypes = {
  isSecondModal: PropTypes.bool
}


const mapDispatchToProps = (dispatch) => {
  return {
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message))
  }
}

export default connect(null, mapDispatchToProps)(AddLocation)



// WEBPACK FOOTER //
// ./src/modals/AddLocation/index.js